import React, { useState } from 'react';
import { X, Send, Check, Loader2, Heart } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const QuickContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      await axios.post(`${API}/contacts`, {
        ...formData,
        message: 'Pedido de contacto rápido via formulário da homepage',
      });
      setIsSubmitted(true);
    } catch (err) {
      console.error('Error submitting contact:', err);
      setError('Ocorreu um erro. Por favor, tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    // Reset form state when closing
    setTimeout(() => {
      setFormData({ name: '', phone: '', email: '' });
      setIsSubmitted(false);
      setError('');
    }, 300);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in"
      onClick={handleClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[#2C2C2C]/60 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className="relative bg-[#FAF9F7] rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-[#8B7D6B] hover:text-[#2C2C2C] transition-colors z-10"
          aria-label="Fechar"
        >
          <X size={24} />
        </button>

        {/* Decorative header */}
        <div className="bg-gradient-to-r from-[#D4C4B0]/40 to-[#B5C4B1]/30 px-8 pt-8 pb-6">
          <div className="text-center">
            <p className="text-caption text-[#8B7D6B] mb-2">
              Alma Leve Weddings
            </p>
            <h3 className="font-['Cormorant_Garamond'] text-2xl md:text-3xl text-[#2C2C2C]">
              Vamos conversar?
            </h3>
          </div>
        </div>

        {/* Content */}
        <div className="p-8">
          {isSubmitted ? (
            <div className="text-center py-6">
              <div className="w-16 h-16 rounded-full bg-[#B5C4B1]/30 flex items-center justify-center mx-auto mb-6">
                <Heart size={32} className="text-[#6B4E37]" fill="#D4C4B0" />
              </div>
              <h4 className="font-['Cormorant_Garamond'] text-2xl text-[#2C2C2C] mb-3">
                Obrigada pelo seu contacto!
              </h4>
              <p className="text-body text-[#8B7D6B] mb-2">
                Será contactado(a) muito em breve.
              </p>
              <p className="text-sm text-[#C4B5A0]">
                Estou ansiosa por conhecer a vossa história de amor.
              </p>
              <button
                onClick={handleClose}
                className="btn-primary mt-8"
              >
                Fechar
              </button>
            </div>
          ) : (
            <>
              <p className="text-body text-[#6B4E37] text-center mb-6">
                Deixe os seus dados e entrarei em contacto consigo brevemente para começarmos a planear o vosso dia especial.
              </p>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label htmlFor="quick-name" className="block text-sm text-[#8B7D6B] mb-2">
                    Nome *
                  </label>
                  <input
                    type="text"
                    id="quick-name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="O vosso nome"
                  />
                </div>

                <div>
                  <label htmlFor="quick-email" className="block text-sm text-[#8B7D6B] mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="quick-email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="email@exemplo.pt"
                  />
                </div>

                <div>
                  <label htmlFor="quick-phone" className="block text-sm text-[#8B7D6B] mb-2">
                    Telemóvel *
                  </label>
                  <input
                    type="tel"
                    id="quick-phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="+351 900 000 000"
                  />
                </div>

                {error && (
                  <p className="text-red-500 text-sm text-center">{error}</p>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 size={18} className="animate-spin" />
                      A enviar...
                    </>
                  ) : (
                    <>
                      <Send size={18} />
                      Quero ser contactado(a)
                    </>
                  )}
                </button>
              </form>

              <p className="text-xs text-[#8B7D6B] text-center mt-6">
                Os seus dados serão tratados com total confidencialidade.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickContactModal;
